import React from 'react'
import { withRouter } from "react-router-dom";
import { TableOp } from '../../../components/table/TableOps.tsx';
import TableComponent from '../../../components/table/TableOps';
import TipoSeguimiento from './TipoSeguimiento'
import ACCESS from '../../../ACCESS.js';

class TiposSeguimientoGuias extends TableComponent {

  componentDidMount() {
    this.tableConfig(
      { dataUrl: 'tipo-seguimiento/filter', deleteUrl: 'tipo-seguimientotipo-seguimientos/delete', deleteField: 'tipo_seguimiento_guia', modUrl: '/Catalogo/TipoSeguimiento' },
      TableOp.Table('Tipos Seguimiento Guias', [
        { label: 'Nombre', id: 'tipo_seguimiento_guia' },
      ], [
        { id: 'edit', icon: 'edit', access: [ACCESS.CATALOGO_TIPOS_SEGUIMIENTO_DE_GUIAS.EDITAR_CATALOGO] },
        { id: 'delete', icon: 'delete', access: [ACCESS.CATALOGO_TIPOS_SEGUIMIENTO_DE_GUIAS.ELIMINAR_CATALOGO] },
      ]))
    this.table();
  }

  render() {

    return (
      <div>
        <div>
        {
           
          <TipoSeguimiento  onSave={() => {this.table()}} />
        }
        {
           
          <this.TableRender  />
        }
        </div>
      </div>
    )
  }
}

export default withRouter(TiposSeguimientoGuias)